import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, ButtonGroup, Glyphicon, Panel} from 'react-bootstrap'
import IntakeForm, {createIntakeInitialValues} from '../intake/IntakeForm'
import * as Date from "../../utils/date"
import {IntakeType, IntakeTypeLabel} from "../../utils/enums";
import {Enums} from "../../utils";
import {formatItemActions, renderItemTable} from "./helpers";
import {formatIntakeDescription} from "../../utils/format";

class DogIntakes extends Component {

	constructor(props) {
		super(props);

		this.state = {
			itemModalOpen: false,
			itemModalMode: null,
			itemModalItem: null,
			intakeId: null
		};

		this.handleItemModalClick = this.handleItemModalClick.bind(this);
		this.handleItemModalDismiss = this.handleItemModalDismiss.bind(this);

		this.tableCtx = {
			itemKeyName: 'intakeId',
			cols: [
				{title: 'Datum', width: 17},
				{title: 'Typ', width: 17},
				{title: 'Popis', width: 39},
				{title: 'Provedl', width: 17},
			],
			renderRow: (item, files, props) => {
				const {enums} = props;
				return <tr key={item.intakeId} title={item.createdBy && Enums.getEnumTitle(enums, 'user', item.createdBy) + ' ' + Date.formatDateTime(item.createdAt)}>
					<td title={item.intakeId}>
						{Date.formatDate(item.intakeAt)}
						{item.dogNumber && '#' + item.dogNumber}
						{item.dogName && ' (' + item.dogName + ')'}
					</td>
					<td>{IntakeTypeLabel[item.intakeType]}</td>
					<td>{formatIntakeDescription(item)}</td>
					<td>{item.intakeBy && Enums.getEnumTitle(enums, 'user', item.intakeBy)}</td>
					<td>{formatItemActions(item, 'intakeId', files, this.handleItemModalClick, item.intakeType === IntakeType.H)}</td>
				</tr>;
			},
		};
	}

	componentWillMount() {
		this.props.onFetchData(this.props.dogId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.dogId !== this.props.dogId) {
			this.props.onFetchData(nextProps.dogId)
		}
	}

	handleItemModalClick(intakeId, itemModalMode = 'edit', itemModalItem = null) {
		this.setState({itemModalOpen: true, intakeId, itemModalMode, itemModalItem})
	}

	handleItemModalDismiss() {
		this.setState({itemModalOpen: false, intakeId: null, itemModalMode: null, itemModalItem: null})
	}

	renderItemModal() {
		const {dogId, dog, session} = this.props;
		const {itemModalOpen, intakeId, itemModalMode, itemModalItem} = this.state;
		if (!itemModalOpen) {
			return null
		}

		const modal = {
			onHide: this.handleItemModalDismiss,
			onSuccess: (item) => this.props.onFetchData(item.dogId, true)
		};

		return <IntakeForm intake={createIntakeInitialValues(intakeId, dogId, session, dog, itemModalMode === 'clone' ? itemModalItem : undefined)} modal={modal}/>
	}

	render() {
		return <Panel>
			<Panel.Heading>
				<div className={'panel-title'}>
					Příjem
					<ButtonGroup className="pull-right">
						<Button type="button" className="btn-sm" onClick={() => this.handleItemModalClick(null)}><Glyphicon glyph="plus"/> Přidat</Button>
					</ButtonGroup>
				</div>
			</Panel.Heading>
			<Panel.Body>
				{renderItemTable(this.tableCtx, this.props)}
				{this.renderItemModal()}
			</Panel.Body>
		</Panel>
	}
}

DogIntakes.propTypes = {
	dogId: PropTypes.number,
	dog: PropTypes.object,
	files: PropTypes.array,
	onFetchData: PropTypes.func.isRequired,
	onShowModal: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired
}

export default DogIntakes



// WEBPACK FOOTER //
// ./src/components/dog/DogIntakes.js